const SIDEBAR = {
	OPTIONS: {
		MY_CLASSES: "Minhas turmas",
		OLD_CLASSES: "Turmas arquivadas",
		NOTIFICATIONS: "Notificações",
		ABOUT: "Sobre",
	},
	SHOW_LESS: "Mostrar menos",
};

export default SIDEBAR;